export default __webpack_public_path__ + "static/media/st.1aa4d1fc.jpg";